var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverSpeedEventsPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Over Speed Events",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Over Speed Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0123,10.5c0,5.8-9.997,14.5-9.997,14.5C10.0153,25,.01825,16.3,.01825,10.5-.11646,4.84036,4.35748,.1413,10.0153,0c5.6578,.1413,10.1318,4.84036,9.997,10.5Z",
    fill: "#d11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6833,7.83426c-.0729-.1884-.2796-.27995-.4616-.20448-.182,.07546-.2704,.28937-.1975,.47777l.0087,.02069c1.1174,2.65486,.1228,5.75456-2.3068,7.19006-.1676,.1052-.2211,.3312-.1194,.5048,.0976,.1666,.3039,.2253,.4701,.1339,2.746-1.6207,3.87-5.1235,2.6065-8.12274ZM7.23485,15.2903c-2.16327-1.27-3.2098-3.9044-2.53546-6.3823h-.73273c-.65924,2.7517,.53217,5.6211,2.91461,7.0195,.16999,.1015,.38726,.0411,.4853-.1348,.09804-.176,.0397-.4009-.13029-.5024M12.5486,4.5593c-.798-.36972-1.6626-.56034-2.5369-.5593h-.02839c-1.18369-.00005-2.3423,.3531-3.33706,1.01718l.43453,.58796c.86939-.56673,1.8758-.86762,2.90323-.86797h.02489c.7751-.00091,1.5417,.1679,2.2493,.49536,.1768,.08778,.3888,.01062,.4736-.17237,.0848-.18298,.0103-.40249-.1665-.49027l-.0181-.00837m1.9305,1.74109c.1362-.14598,.1323-.37861-.0087-.51961-.1376-.13756-.3557-.13756-.4933,0l-3.053,3.16029c-.7869-.54393-1.8508-.32458-2.37629,.48994-.52549,.81447-.31356,1.91577,.47331,2.45967,.78687,.544,1.85078,.3246,2.37628-.4899,.3758-.5826,.3851-1.3397,.0237-1.93202l3.058-3.16837Zm-6.8992,1.94321H3.05501c-.19607,0-.35501-.16453-.35501-.36747,0-.0795,.02491-.15687,.071-.22049l2.26353-3.05519c.1301-.16094,.36161-.18224,.51709-.04757,.01664,.01441,.03202,.03033,.04595,.04757l2.26068,3.05225c.11764,.16236,.08585,.39269-.071,.51446-.06145,.04771-.13618,.0735-.213,.0735",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverSpeedEventsPoint);
export default __webpack_public_path__ + "static/media/over-speed-events-point.6d30cdd522b06bf753b1a93f4b166c7a.svg";
export { ForwardRef as ReactComponent };